var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNovideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5835 22.7487C7.5835 18.7262 9.18141 14.8685 12.0257 12.0242C14.87 9.17994 18.7277 7.58203 22.7502 7.58203H68.2502C72.2726 7.58203 76.1303 9.17994 78.9746 12.0242C81.8189 14.8685 83.4168 18.7262 83.4168 22.7487V68.2487C83.4168 72.2712 81.8189 76.1289 78.9746 78.9732C76.1303 81.8175 72.2726 83.4154 68.2502 83.4154H22.7502C18.7277 83.4154 14.87 81.8175 12.0257 78.9732C9.18141 76.1289 7.5835 72.2712 7.5835 68.2487V22.7487Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2294 41.7083C37.4646 41.7083 41.7086 37.4644 41.7086 32.2292C41.7086 26.994 37.4646 22.75 32.2294 22.75C26.9942 22.75 22.7502 26.994 22.7502 32.2292C22.7502 37.4644 26.9942 41.7083 32.2294 41.7083Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.078 47.8488L22.7502 83.4109H68.7545C72.6432 83.4109 76.3727 81.8661 79.1224 79.1164C81.8721 76.3666 83.4169 72.6372 83.4169 68.7485V68.2442C83.4169 66.4773 82.7534 65.7986 81.559 64.4905L66.2786 47.8261C65.5664 47.0492 64.7001 46.4293 63.735 46.006C62.7699 45.5826 61.7272 45.3651 60.6733 45.3672C59.6194 45.3693 58.5775 45.5911 57.6141 46.0184C56.6507 46.4457 55.787 47.0691 55.078 47.8488V47.8488Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovideo);
export default __webpack_public_path__ + "static/media/novideo.69ce2724db5e2da996aa93d77a6bdb99.svg";
export { ForwardRef as ReactComponent };